// Motor Specific Storage Identifiers
export const SELECTED_MOTOR_QUOTE_STORAGE = 'selectedMotorQuote';
export const RECALCULATED_QUOTE_RESPONSE_STORAGE = 'recalculateQuoteResponse';
